import Page from 'pages/Page';

export default class Landing extends Page {
  constructor() {
    super();
  }
}

new Landing();
